import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen bg-[#050505] flex items-center justify-center">
                <div className="spinner" />
            </div>
        );
    }

    if (user === false) {
        // Preserve the intended destination so login/signup can bounce
        // the player straight to the room (or wherever they were headed)
        // once they authenticate. Critical for shared invite links.
        const next = `${location.pathname}${location.search}${location.hash}`;
        const suffix = next && next !== '/' ? `?next=${encodeURIComponent(next)}` : '';
        return <Navigate to={`/login${suffix}`} replace state={{ from: location }} />;
    }

    if (adminOnly && user?.role !== 'admin') {
        return <Navigate to="/lobby" replace />;
    }

    return children;
};

export default ProtectedRoute;
